import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Chicken Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fchicken-bowl.34bdd721.webp&w=3840&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffrozen-chicken-pouch-white-wrapper.5291ada1.webp&w=3840&q=75',
    ],
    description:
      'A delicious single-protein recipe, naturally hydrating and packed with nutrients. Formulated by a PhD nutrition expert to be complete + balanced for dogs of all life stages.',
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/chicken',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Chicken',
      },
      {
        '@type': 'PropertyValue',
        name: 'Chicken Quality',
        value: 'Made with Cage-Free Chicken',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '9.66',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/chicken',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '16.10',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '9.66',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isRelatedTo: {
      '@type': 'Product',
      name: 'Chicken Recipe',
      url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/beef',
      },
      {
        '@type': 'Product',
        name: 'Turkey Recipe',
        url: 'https://wefeedraw.com/recipes/turkey',
      },
      {
        '@type': 'Product',
        name: 'Duck Recipe',
        url: 'https://wefeedraw.com/recipes/duck',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:CHICKEN.page-title')}</title>
        <meta name="title" content={t('recipes:CHICKEN.meta-title')} />
        <meta
          name="description"
          content={t('recipes:recipe-detail-meta-description', {
            protein: Proteins.CHICKEN.toLowerCase(),
          })}
        />
        <link rel="canonical" href="https://wefeedraw.com/recipes/chicken" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.CHICKEN} />
      </main>
    </div>
  )
}
